import Router, { useRouter } from 'next/router';
import { useAuth } from '@context/auth/base';
import { useConnectedAuth } from '@context/auth/connected';
import { NAV_LINKS } from '@utils/constants';
import { webappUriPath } from '@utils/url';

export const useNavActions = () => {
  const { pathname, asPath } = useRouter();
  const { isAuthenticatedWithAPI, authUser } = useAuth();
  const { login } = useConnectedAuth();

  const userUrl = webappUriPath(authUser?.webappUri ?? '');

  const isHomepageActive = pathname === NAV_LINKS.Home;
  const isFeedActive = pathname === NAV_LINKS.Feed;
  const isSearchActive = pathname.includes(NAV_LINKS.Explore);
  const isExploreActive = pathname.includes(NAV_LINKS.Explore);
  const isNotificationActive = pathname.includes(NAV_LINKS.NotificationPage);
  const isProfileActive =
    (pathname.includes('/[soundHandle]') && asPath === webappUriPath(authUser?.webappUri || '')) ||
    (pathname.includes(`/user/[publicAddress]`) &&
      asPath === webappUriPath(authUser?.webappUri || ''));
  const isSignInActive = pathname === NAV_LINKS.SignIn;

  const onNotificationsClick = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isAuthenticatedWithAPI) {
      const authResponse = await login();
      if (authResponse.status === 'success') {
        Router.push(NAV_LINKS.NotificationPage);
      }
      return;
    }
    Router.push(NAV_LINKS.NotificationPage);
    return;
  };

  const onProfileClick = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isAuthenticatedWithAPI) {
      const authResponse = await login();
      if (authResponse.status === 'success') {
        const url = webappUriPath(authResponse.data.authUser?.webappUri ?? '');
        Router.push(url);
      }
      return;
    }
    Router.push(userUrl);
    return;
  };

  return {
    onNotificationsClick,
    onProfileClick,
    isHomepageActive,
    isFeedActive,
    isSearchActive,
    isExploreActive,
    isNotificationActive,
    isProfileActive,
    isSignInActive,
  };
};
